import { everett } from 'lib/styles/fonts';

export const BODY_TYPEFACE = everett.style.fontFamily;
export const HEADING_TYPEFACE = everett.style.fontFamily;

const typography = {
  fonts: {
    heading: HEADING_TYPEFACE,
    body: BODY_TYPEFACE,
    everett: BODY_TYPEFACE,
  },
  textStyles: {
    h2: {
      fontSize: [ '32px' ],
      fontWeight: '500',
      lineHeight: '40px',
      fontFamily: 'everett',
    },
    h3: {
      fontSize: '24px',
      fontWeight: '500',
      lineHeight: '32px',
      fontFamily: 'everett',
    },
    h4: {
      fontSize: 'md',
      fontWeight: '500',
      lineHeight: '24px',
      fontFamily: 'everett',
    },
  },
};

export default typography;
